import star from '../../../../assests/icons/star.png'
import { useSelector } from 'react-redux';
import classes from './PointsScore.module.css';
import Tooltip from '../../../ui/tooltip/Tooltip';

const PointsScore = ({ score }) => {

    const { texts } = useSelector(state => state.translate);
    const { isAuth, isStudent } = useSelector((state) => state.auth);

    return (
        (!isAuth || isStudent) &&
        <Tooltip text={texts.myScore} showTooltip={true}>
            <div className={classes.PointsScore}>
                <div className={classes.Star}>
                    <p className={classes.StarNum}>{score}</p>
                    <img alt={texts.stars} className={classes.StarImg} src={star} />
                </div>
            </div>
        </Tooltip>
    )
}

export default PointsScore;